<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="home">
  <div class="hero">
    <picture>
      <source
        media="(min-width: 992px)"
        srcset="images/landing/hero-xl.svg 1x, images/landing/hero-xl.svg 2x"
        type="image/svg+xml" />
      <source
        media="(min-width: 992px)"
        srcset="
          images/landing/hero-xl.png    1x,
          images/landing/hero-xl@2x.png 2x
        " />
      <source
        media="(max-width: 575px)"
        srcset="images/landing/hero-xs.svg 1x, images/landing/hero-xs.svg 2x"
        type="image/svg+xml" />
      <source
        media="(max-width: 575px)"
        srcset="
          images/landing/hero-xs.png    1x,
          images/landing/hero-xs@2x.png 2x
        " />
      <source
        media="(max-width: 991px)"
        srcset="images/landing/hero-m.svg 1x, images/landing/hero-m.svg 2x"
        type="image/svg+xml" />
      <source
        media="(max-width: 991px)"
        srcset="
          images/landing/hero-m.png    1x,
          images/landing/hero-m@2x.png 2x
        " />
      <img
        class="img-fluid hero-image"
        src="images/landing/hero-xl.png"
        [alt]="'SDE_LOCATION_INSTANT_ACCESS' | xdaTranslate"
        srcset="images/landing/hero-xl@2x.png 2x" />
    </picture>
    <div class="hero-content">
      <div class="d-flex flex-center flex-column">
        <picture>
          <source
            srcset="
              images/landing/app_icon.svg 1x,
              images/landing/app_icon.svg 2x
            "
            type="image/svg+xml" />
          <img
            class="app-icon"
            src="images/landing/app_icon.png"
            srcset="images/landing/app_icon@2x.png 2x"
            alt="Xerox® Workflow Central" />
        </picture>
        <h1 class="display-1">Xerox<sup>®</sup> Workflow Central</h1>
        <h4 class="title-3 text-center" xdaTranslate>
          SDE_LOCATION_INSTANT_ACCESS
        </h4>
        <div class="hero-buttons">
          <button
            class="xrx-btn btn-secondary btn-lg"
            (click)="learnMore('hero')"
            xdaTranslate>
            SDE_LEARN_MORE
          </button>
          <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
          <button
            class="xrx-btn btn-primary btn-lg"
            (click)="tryIt()"
            [xdaTranslate]="'SDE_TRY_OR_BUY'"></button>
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper">
    <div class="page-body">
      <div class="intro workflow-intro text-center">
        <h2 class="title-2" xdaTranslate>SDE_DRIVE_PRODUCTIVITY_NEXT</h2>
        <p xdaTranslate>SDE_INNOVATIVE_SET_TOOLS</p>
      </div>
      <div class="d-flex flex-wrap justify-content-center workflows">
        <div class="workflow text-center">
          <picture>
            <source
              srcset="
                images/landing/doc_security.svg 1x,
                images/landing/doc_security.svg 2x
              "
              type="image/svg+xml" />
            <img
              class="img-fluid"
              src="images/landing/doc_security.png"
              [alt]="'SDE_ENHANCED_DOCUMENT_SECURITY' | xdaTranslate"
              srcset="images/landing/doc_security@2x.png 2x" />
          </picture>
          <h4 class="title-4" xdaTranslate>SDE_ENHANCED_DOCUMENT_SECURITY</h4>
        </div>
        <div class="workflow text-center">
          <picture>
            <source
              srcset="
                images/landing/doc_conversion.svg 1x,
                images/landing/doc_conversion.svg 2x
              "
              type="image/svg+xml" />
            <img
              class="img-fluid"
              src="images/landing/doc_conversion.png"
              [alt]="'SDE_CONVERSION_MORE_USEFUL' | xdaTranslate"
              srcset="images/landing/doc_conversion@2x.png 2x" />
          </picture>
          <h4 class="title-4" xdaTranslate>SDE_CONVERSION_MORE_USEFUL</h4>
        </div>
        <div class="workflow text-center">
          <picture>
            <source
              srcset="
                images/landing/translate.svg 1x,
                images/landing/translate.svg 2x
              "
              type="image/svg+xml" />
            <img
              class="img-fluid"
              src="images/landing/translate.png"
              [alt]="'SDE_ON_GO_TRANSLATION' | xdaTranslate"
              srcset="images/landing/translate@2x.png 2x" />
          </picture>
          <h4 class="title-4" xdaTranslate>SDE_ON_GO_TRANSLATION</h4>
        </div>
        <div class="workflow text-center">
          <picture>
            <source
              srcset="
                images/landing/doc_merge.svg 1x,
                images/landing/doc_merge.svg 2x
              "
              type="image/svg+xml" />
            <img
              class="img-fluid"
              src="images/landing/doc_merge.png"
              [alt]="'SDE_DOCUMENT_MERGING_SUMMARIZATION' | xdaTranslate"
              srcset="images/landing/doc_merge@2x.png 2x" />
          </picture>
          <h4 class="title-4" xdaTranslate>
            SDE_DOCUMENT_MERGING_SUMMARIZATION
          </h4>
        </div>
        <div class="workflow text-center">
          <picture>
            <source
              srcset="
                images/landing/workflow.svg 1x,
                images/landing/workflow.svg 2x
              "
              type="image/svg+xml" />
            <img
              class="img-fluid"
              src="images/landing/workflow.png"
              [alt]="'SDE_POWERFUL_PRESET_COMBINATION' | xdaTranslate"
              srcset="images/landing/workflow@2x.png 2x" />
          </picture>
          <h4 class="title-4" xdaTranslate>SDE_POWERFUL_PRESET_COMBINATION</h4>
        </div>
      </div>
      <div class="text-center">
        <button
          class="xrx-btn btn-secondary btn-lg learn-more single"
          (click)="learnMore('drive')"
          xdaTranslate>
          SDE_LEARN_MORE
        </button>
      </div>
      <div class="intro automated-intro text-center">
        <h2 class="title-2" xdaTranslate>SDE_CREATE_AUTOMATED_WORKFLOWS</h2>
        <p xdaTranslate>SDE_HAVE_EVERYDAY_TASK</p>
      </div>
      <div class="automated-image">
        <picture>
          <source
            media="(min-width: 576px)"
            srcset="
              images/landing/workflow_process-xl.svg 1x,
              images/landing/workflow_process-xl.svg 2x
            "
            type="image/svg+xml" />
          <source
            media="(min-width: 576px)"
            srcset="
              images/landing/workflow_process-xl.png    1x,
              images/landing/workflow_process-xl@2x.png 2x
            " />
          <source
            media="(max-width: 575px)"
            srcset="
              images/landing/workflow_process-xs.svg 1x,
              images/landing/workflow_process-xs.svg 2x
            "
            type="image/svg+xml" />
          <source
            media="(max-width: 575px)"
            srcset="
              images/landing/workflow_process-xs.png    1x,
              images/landing/workflow_process-xs@2x.png 2x
            " />
          <img
            class="img-fluid"
            src="images/landing/workflow_process-xl.png"
            [alt]="'SDE_CREATE_AUTOMATED_WORKFLOWS' | xdaTranslate"
            srcset="images/landing/workflow_process-xl@2x.png 2x" />
        </picture>
      </div>
      <div class="text-center">
        <button
          class="xrx-btn btn-secondary btn-lg learn-more single"
          (click)="learnMore('automated')"
          xdaTranslate>
          SDE_LEARN_MORE
        </button>
      </div>

      <div class="intro access-intro text-center">
        <h2 class="title-2" xdaTranslate>SDE_FLEXIBLE_ACCESS_ANYTIME1</h2>
        <p xdaTranslate>SDE_ACCESS_WORKFLOW_CENTRAL</p>
      </div>

      <div class="access-image">
        <picture>
          <source
            media="(min-width: 576px)"
            srcset="
              images/landing/displays-xl.svg 1x,
              images/landing/displays-xl.svg 2x
            "
            type="image/svg+xml" />
          <source
            media="(min-width: 576px)"
            srcset="
              images/landing/displays-xl.png    1x,
              images/landing/displays-xl@2x.png 2x
            " />
          <source
            media="(max-width: 575px)"
            srcset="
              images/landing/displays-xs.svg 1x,
              images/landing/displays-xs.svg 2x
            "
            type="image/svg+xml" />
          <source
            media="(max-width: 575px)"
            srcset="
              images/landing/displays-xs.png    1x,
              images/landing/displays-xs@2x.png 2x
            " />
          <img
            class="img-fluid"
            src="images/landing/displays-xl.png"
            [alt]="'SDE_FLEXIBLE_ACCESS_ANYTIME1' | xdaTranslate"
            srcset="images/landing/displays-xl@2x.png 2x" />
        </picture>
      </div>
      <div class="access-buttons d-flex justify-content-center">
        <div class="button-wrapper">
          <button
            class="xrx-btn btn-secondary btn-lg"
            (click)="learnMore('access')"
            xdaTranslate>
            SDE_LEARN_MORE
          </button>
          <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
          <button
            class="xrx-btn btn-primary btn-lg"
            (click)="tryIt()"
            [xdaTranslate]="'SDE_TRY_OR_BUY'"></button>
        </div>
      </div>
    </div>
  </div>
</div>
